class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.checkoutWarningPopin = document.querySelector('cart-checkout-warning-popup');
    this.addEventListener('click', event => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.upsells = document.querySelectorAll('.cart-page__upsell');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);

    this.initUpsells();

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
    );
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
      .then(response => {
        return response.text();
      })
      .then(state => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach(overlay =>
          overlay.classList.add('hidden'),
        );
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value,
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  extractLineItems(cartJSON) {
    return cartJSON.reduce((accumulator, item) => {
      accumulator[item.variant_id] = (accumulator[item.variant_id] || 0) + item.quantity;
      return accumulator;
    }, {});
  }

  initUpsells() {
    if (!this.upsells?.length) return;

    // Init upsell "Add to cart" buttons
    this.upsells.forEach(upsell => {
      const addBundleToCartBtns = upsell.querySelectorAll('[data-action="add-bundle"]');

      if (!addBundleToCartBtns.length) return;

      const originProductVariantId = addBundleToCartBtns[0].dataset.originProductVariantId;
      const targetProductVariantId = addBundleToCartBtns[0].dataset.targetProductVariantId;
      const productQuantityInput =
      addBundleToCartBtns[0].closest('.cart-item').querySelector('.quantity__input');
      const productQuantity =
      Number(productQuantityInput?.value) ||
      1;
      

      if (originProductVariantId && targetProductVariantId) {
        // todo take into account previous quantities and decrement/increment the,
        addBundleToCartBtns.forEach(addBundleToCartBtn => {
          addBundleToCartBtn.addEventListener('click', e => {
            e.preventDefault();
            fetch('/cart.js')
              .then(response => response.json())
              .then(response => {
                let currentLineItems = this.extractLineItems(response.items);

                // Remove origin_product quantity just added to cart
                if (currentLineItems.hasOwnProperty(originProductVariantId)) {
                  currentLineItems[originProductVariantId] -= productQuantity;
                }

                // Check if the targetProductVariantId exists in the object
                if (currentLineItems.hasOwnProperty(targetProductVariantId)) {
                  // If the key exists, increase its value by productQuantity
                  currentLineItems[targetProductVariantId] += productQuantity;
                } else {
                  // If the key doesn't exist, add a new key-value pair
                  currentLineItems[targetProductVariantId] = productQuantity;
                }

                const requestBody = JSON.stringify({
                  updates: currentLineItems,
                  sections: this.getSectionsToRender().map(section => section.section),
                  sections_url: window.location.pathname,
                });

                const config = fetchConfig('javascript');
                config.body = requestBody;

                return config;
              })
              .then(config => fetch(`${routes.cart_update_url}`, config))
              .then(response => response.text())
              .then(state => {
                const parsedState = JSON.parse(state);
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach(section => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) ||
                    document.getElementById(section.id);

                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector,
                  );
                });

                const line = productQuantityInput?.dataset.index || -1;
                this.updateLiveRegions(
                  line,
                  parsedState.item_count,
                );
                this.disableLoading();
              });
          });
        });
      }
    });
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(overlay =>
      overlay.classList.remove('hidden'),
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

class CartCheckoutWarningPopup extends HTMLElement {
  constructor() {
    super();

    this.cart = document.getElementById('cart');
    this.blockCheckoutBtn();
    this.initPopin();
  }

  togglePopin(show) {
    this.setAttribute('open', show);
    document.body.style.overflowY = show ? 'hidden' : 'unset';
  }

  preventFormAndShowPopin = event => {
    event.preventDefault();
    if (this.hasBlockingProducts()) {
      this.togglePopin(true);
    } else {
      window.location.href = '/checkout';
    }
  };

  blockCheckoutBtn() {
    this.cart.addEventListener('submit', this.preventFormAndShowPopin);
  }

  hasBlockingProducts() {
    const cartProductHandles = this.dataset.productHandles;
    const cartProductHandlesArray = cartProductHandles.split('|');

    return cartProductHandlesArray.some(
      productHandle =>
        productHandle.length &&
        document.querySelector(`.cart-item[data-handle='${productHandle}']`) != null,
    );
  }

  unblockCheckoutBtn() {
    // Unblock checkout btn if no product from the product handle list remains in the cart
    if (!this.hasBlockingProducts()) {
      this.cart.removeEventListener('submit', this.preventFormAndShowPopin);
    }
  }

  initPopin() {
    // Init close button
    const closeBtn = this.querySelector('.product-upsell__close');
    if (closeBtn) closeBtn.addEventListener('click', () => this.togglePopin(false));

    // Init "No thanks" button
    const noThanksBtn = this.querySelector('[data-action="close-popin"]');
    if (noThanksBtn) noThanksBtn.addEventListener('click', () => this.togglePopin(false));

    // Init "Accept" button
    const acceptBtn = this.querySelector('[data-action="accept"]');
    if (acceptBtn) acceptBtn.addEventListener('click', () => (window.location.href = '/checkout'));
  }
}

customElements.define('cart-checkout-warning-popup', CartCheckoutWarningPopup);
  